import RobotOutlined from '@ant-design/icons/RobotOutlined'
import { Avatar, Card } from 'antd'
import React, { FC } from 'react'
import styled from 'styled-components'

import { LlmMessageText } from './MessageBubble'

const MessageRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
`

const MessageContent = styled.div`
  max-width: 70%;
`

export const LoadingMessage: FC = () => (
  <MessageRow>
    <Avatar
      size='small'
      icon={<RobotOutlined />}
      style={{ backgroundColor: '#52c41a' }}
    />
    <MessageContent>
      <Card
        size='small'
        style={{
          backgroundColor: '#f0f0f0',
          borderRadius: '18px 18px 18px 4px',
        }}>
        <LlmMessageText $isUser={false}>AI is thinking...</LlmMessageText>
      </Card>
    </MessageContent>
  </MessageRow>
)
